<template>
  <div class="open-service-form">
    <a-form
      ref="createForm"
      :form="form"
      class="form"
      :class="{'en-open-form': isEnglish}"
    >
      <a-form-item :label="`${projectNameTit}：`">
        <span class="cell-content">{{ serviceInfo.projectname }}</span>
      </a-form-item>
      <a-form-item :label="`${curTeamMembers}：`">
        <span class="cell-content">{{ serviceInfo.user_num }}{{ isEnglish ? '' : $t('message["929"]') }}</span>
        <p class="open-service-tip">
          {{ $t('message["1185"]') }}。
        </p>
      </a-form-item>
      <a-form-item :label="`${freeUpTip}：`">
        <span class="cell-content">3{{ $t('message["367"]') }}</span>
      </a-form-item>
      <div class="module-row">
        <a-form-item :label="`${tipTit}：`">
          <p>
            1.{{ $t('message["354"]') }}<br>
            2.{{ $t('message["1442"]') }}
          </p>
        </a-form-item>
      </div>
      <a-form-item>
        <a-button
          type="primary"
          @click="formHandler"
        >
          {{ $t('message["928"]') }}
        </a-button>
        <a-button @click="closeHandler">
          {{ $t('message["1537"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  data () {
    return {
      form: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('service', ['serviceInfo']),
    curTeamMembers () {
      return this.$t('message["169"]')
    },
    freeUpTip () {
      return this.$t('message["1186"]')
    },
    projectNameTit () {
      return this.$t('message["1325"]')
    },
    tipTit () {
      return this.$t('message["1632"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  methods: {
    ...mapActions('service', ['vipJoin']),
    getLang,
    async formHandler () {
      const chain = await this.vipJoin()
      chain.onSuccess(raw => {
        this.$emit('formHandler')
      })
        .fetch()
    },
    closeHandler () {
      this.$emit('closeHandler')
    }
  }
}
</script>
<style lang="scss" scoped>
.open-service-form::v-deep {
  margin-right: -10px;
  .ant-form-inline .ant-form-item {
    margin-bottom: 24px;
    display: block;
  }
  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {
    padding-left: 94px;
    .ant-input-number {
      width: 160px;
    }
    .ant-form-item-label {
      float: left;
      width: 94px;
      margin-left: -94px;
      label {
        color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
      .cell-content {
        font-weight: bold;
      }
      .open-service-tip {
        color: #b3b3b3;
        margin-top: -5px;
      }
    }
  }
  .en-open-form {
    .ant-row {
    padding-left: 164px;
    .ant-form-item-label {
      float: left;
      width: 164px;
      margin-left: -164px;
    }
  }
  }
  .module-row {
    padding-top: 12px;
    position: relative;
    border-top: 1px solid #ebebeb;
    padding-bottom: 24px;
    .ant-row {
      color:#F6A953 !important;
      p{
        line-height: 24px;
        padding-top: 4px;
      }
    }
  }
}
</style>
